import React from "react";
import { socialNetworks } from "../../../constants/socialNetworks";
//import { Link } from "react-router-dom";
import { SocialNetworksContainer } from "./SocialNetworks.styled";
import { Link } from "@mui/material";

const SocialNetworks: React.FC<{ whiteIcon?: boolean }> = ({ whiteIcon }) => {
  return (
    <SocialNetworksContainer>
      {socialNetworks.map((socialNetwork) => (
        <Link key={socialNetwork.name} href={socialNetwork.url} target="_blank">
          {whiteIcon ? socialNetwork.iconWhite : socialNetwork.icon}
        </Link>
      ))}
    </SocialNetworksContainer>
  );
};

export default SocialNetworks;
